import Vue from 'vue'
import axios from 'axios';
import router from '../../router'
import qs from 'qs';
import utile from '../public/utile.js';
// Vue.prototype.$host = '/api'
// axios.defaults.baseURL = '/api';

var imgUrl = 'http://program.job500.cn/';
var apiUrl = 'http://www.job500.cn/'
// var imgUrl = 'http://program-test.job500.cn/';
// var apiUrl = 'http://test.job500.cn/'
axios.defaults.withCredentials = true;
axios.defaults.baseURL = imgUrl;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
const POST = function(url, data, callback) {
    if (tokefun() == '') {
        axios.post(url, qs.stringify(data)).then(function(res) {
            if (res.data.code != 200) {
                exitfun(res.data);
            } else {
                callback(res.data);
            }
        }).catch(function(res) {
            responseFun(res.response)
        })
    } else {
        axios.post(url, qs.stringify(data), { headers: { 'token': tokefun() } }).then(function(res) {
            if (res.data.code != 200) {
                exitfun(res.data);
            } else {
                callback(res.data);
            }
        }).catch(function(res) {
            responseFun(res.response)
        })
    }
}

const responseFun = function(res){
    if(res != undefined){
        if(res.data.code == 500){
            utile.errTemplate(res.data.msg);
            }else if(res.data.code == 401){
            if (res.data.msg == '缺少token') {
                utile.errTemplate('请先登录账号...');
            } else {
                utile.errTemplate('登录超时请重新登录...');
                router.replace({ name: 'Index' });
            }
        }
    }
}

const tokefun = function() {
    var token = localStorage.getItem('token');
    if (token != undefined && token != '' && token != 'undefined' && token != null) {
        return token;
    } else {
        return '';
    }
}

// 退出方法
const exitfun = function(res) {
  if (res.msg == undefined) {
      utile.errTemplate('接口访问超时，请稍后访问...');
      router.replace({ name: 'Index' });
  } else {
      if (res.action == 4) {
          localStorage.setItem('userInfor', '');
          localStorage.setItem('token', '');
          if (res.msg == '缺少token') {
              utile.errTemplate('请先登录用户账号...');
          } else {
              utile.errTemplate('登录超时请重新登录...');
              router.replace({ name: 'Index' });
          }
      } else {
          utile.errTemplate(res.msg);
      }
  }
}

export default {
    POST,
    imgUrl,
    apiUrl
}



// WEBPACK FOOTER //
// ./src/assets/api/controllerApi.js